import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Empty, Pill, when } from "./helpers";

const ST = { restorable: ["Ripristinabile", "bg-sky-50 text-sky-700"], archived: ["Archiviato (non ripristinabile)", "bg-slate-100 text-slate-500"], merged: ["Unito in un altro contatto", "bg-violet-50 text-violet-700"] };

export default function CrmTrash({ tid, tick, onChanged }) {
  const api = useApi();
  const [list, setList] = useState(null);
  const load = useCallback(() => api.get(`/t/${tid}/crm/trash`).then(({ data }) => setList(data)).catch((e) => { setList([]); toast.error(errMsg(e)); }), [api, tid]);
  useEffect(() => { load(); }, [load, tick]);
  const restore = async (x) => { try { await api.post(`/t/${tid}/crm/trash/${x.kind}/${x.id}/restore`); toast.success("Ripristinato"); load(); onChanged?.(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-3" data-testid="crm-trash">
      <p className="text-xs text-slate-500">Contatti e opportunità eliminati restano ripristinabili per 30 giorni, poi vengono archiviati. Nessuna cancellazione automatica finché non è decisa la politica privacy.</p>
      {list === null ? <p className="text-sm text-slate-500">Caricamento…</p> : !list.length ? <Empty testid="trash-empty">Il cestino è vuoto.</Empty> :
        <ul className="divide-y divide-slate-100 rounded-lg border border-slate-200 bg-white">{list.map((x) => (
          <li key={x.id} className="flex flex-wrap items-center gap-3 px-4 py-3" data-testid={`trash-${x.id}`}>
            <div className="min-w-0 flex-1"><p className="truncate text-sm font-medium text-slate-800">{x.label} <span className="text-xs font-normal text-slate-400">· {x.kind === "contact" ? "contatto" : "opportunità"}</span></p>
              <p className="text-xs text-slate-500">eliminato {when(x.deleted_at)}{x.state === "restorable" ? ` · ripristinabile fino al ${when(x.restorable_until)}` : ""}</p></div>
            <Pill tone={ST[x.state][1]} testid={`trash-state-${x.id}`}>{ST[x.state][0]}</Pill>
            {x.state === "restorable" && <Button size="sm" variant="outline" onClick={() => restore(x)} data-testid={`trash-restore-${x.id}`}>Ripristina</Button>}
          </li>))}</ul>}
    </div>
  );
}
